import React from 'react';
import { layout } from '@citrite/web-ui-component';
import styled from '@emotion/styled';
import { ResourceIcon } from 'Components/ResourceIcon';
import { Resource } from 'Workspace/ResourceProvider/resourceTypes';

const StyledDiv = styled.div`
	position: absolute;
	right: ${layout.smallSpace};
	top: ${layout.smallSpace};
	background: rgba(255, 255, 255, 0.6);
	backdrop-filter: blur(5px);
	padding: ${layout.smallSpace};
	border-radius: ${layout.space8};
`;

interface Props {
	resource: Resource;
}

export const DesktopIcon = ({ resource }: Props) => {
	return (
		<StyledDiv>
			<ResourceIcon resource={resource} size={32} />
		</StyledDiv>
	);
};
